module.exports = __webpack_public_path__ + "img/coronavirus4.bedd612b.jpg";